import { ENDPOINTS_EMPLOYEE, ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';
import employeeAssembler from './employeeRepository.assemblers';

class employeeRepositoryService {
  constructor($http, $window) {
    'ngInject';
    this.http = $http;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  getEmployee(employeeId, year, userInceptionId) {
    let endpoint = ENDPOINTS_EMPLOYEE.get.initial(employeeId, year);
    if (userInceptionId) {
      endpoint = ENDPOINTS_MANAGER.get.initialEmployee(employeeId, userInceptionId, year);
    }
    return this.http.get(endpoint).then(response => {
      const employeeData = response.data;
      return employeeAssembler.assemble(employeeId, employeeData);
    });
  }

}

export default employeeRepositoryService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/employeeRepository/employeeRepository.service.js